import React, { useEffect, useState } from 'react'
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import MenuButtons from '../../components/MenuButtons';
import "react-datepicker/dist/react-datepicker.css";

function About() {

    document.title = "Altcoinator | About";

    
     return ( 
        <>
        <div id="wrapper">
          <Header />

          <section className="tf-section tf-wallet"  >
            <div style={{maxWidth:"760px"}} className="container">
              <div className="row">
                <div className="col-md-12">
                      <div className="wallet-form">
                        <MenuButtons/>
                            <hr/>
                                <h4>About</h4>
                                
                            <hr/>
                         <div style={{textAlign:"left"}}>
                            
                         Altcoinator is an ERC20 token creation platform. This platform provides users with the tools and features necessary to create and manage their own ERC20 tokens. This allows users to easily manage and transact their ERC20 tokens through an Ethereum wallet.
                        <br/><br/>
                         Altcoinator automatically generates the smart contracts necessary for users to create their ERC20 tokens. Additionally, the platform provides users with the basic features of their ERC20 tokens (such as token count and token holder tracking). This allows users to find all the tools and features they need to create and manage their ERC20 tokens in one place, greatly facilitating the process of creating and managing ERC20 tokens.
                         <br/><br/>
Altcoinator provides users with the tools and features they need to create and manage their ERC20 tokens. This allows users to find all the tools and features they need to create and manage their ERC20 tokens in one place, greatly facilitating the process of creating and managing ERC20 tokens. Therefore, Altcoinator provides users with the tools and features they need to create and manage their ERC20 tokens. This allows users to find all the tools and features they need to create and manage their ERC20 tokens in one place, greatly facilitating the process of creating and managing ERC20 tokens.






                            
                            
                         </div>

                      </div>
                </div>
               </div>
             </div>
            </section>
          <Footer/>
        </div>
      </> 
  ); 

} 

export default About;